import { extractKeys, getActionType } from './helpers';
import { createReducer } from '../../index';
import { fromJS } from 'immutable';

const reducers = function(endPoints) {
    const reducerNamespaceHash = {};
    const namespaceKeys = extractKeys(endPoints);
    namespaceKeys.forEach(namespace => {
        const reducerPerType = {};
        const endPointsForNamespace = extractKeys(endPoints[namespace]);
        endPointsForNamespace.forEach(endpoint => {
            ['REQUEST', 'SUCCESS', 'FAILED'].forEach(type => {
                const endpointConf = endPoints[namespace][endpoint];
                let reducer = endpointConf.reducer || {};
                reducer =
                    reducer[type] ||
                    function(state, payload) {
                        return state.merge(payload);
                    };
                const reducerType = getActionType(namespace, endpoint, type);
                reducerPerType[[reducerType]] = function(oldState, payload) {
                    return reducer(oldState, payload);
                };
            });
        });
        let initialState = endPoints[namespace]['initialState'] || {};
        reducerNamespaceHash[namespace] = createReducer(fromJS(initialState), reducerPerType);
    });
    return reducerNamespaceHash;
};

export default reducers;
